import { all } from "redux-saga/effects";

import homeSaga from "./home";

// eslint-disable-next-line func-names
export default function* () {
  yield all([homeSaga()]);
}
